import React, { FC, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, IconButton, Paper, Stack, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useUnit } from 'effector-react';
import { isErrorProps } from '../../../../../../apiRPC/request';
import { CardCreativeGroupItem } from '../../../../../../apiRPC/card/creatives/groups';
import { $cardUid, cardCreativesGroupsCreateFX } from './model';

type Form = Pick<CardCreativeGroupItem, 'title'>;
type Props = {
  onCloseCreate: () => void;
};
export const FormCreate: FC<Props> = ({ onCloseCreate }) => {
  const [disabled, setDisable] = useState(false);
  const cardUid = useUnit($cardUid);
  const formik = useFormik<Form>({
    initialValues: { title: '' },
    validationSchema: Yup.object().shape({
      title: Yup.string().trim().required('Обязательное поле'),
    }),
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: false,
    onSubmit: async (values, f) => {
      if (!cardUid) return;
      setDisable(true);
      try {
        await cardCreativesGroupsCreateFX({
          card: cardUid,
          fields: { title: values.title },
        });
        f.resetForm();
      } catch (e) {
        console.error(e);

        if (isErrorProps(e)) {
          e?.data?.fields?.forEach((field) => {
            const text = field.description;
            f.setFieldError(field.field, text);
          });
        }
      } finally {
        setDisable(false);
      }
    },
  });

  return (
    <Paper>
      <Stack
        direction="row"
        padding={1}
        spacing={2}
        component="form"
        onSubmit={formik.handleSubmit}
        noValidate
        alignItems="center"
        width="100%"
        justifyContent="space-between"
      >
        <TextField
          label="Имя"
          variant="standard"
          name="title"
          inputProps={{ maxLength: 255 }}
          autoComplete="none"
          value={formik.values.title}
          error={Boolean(formik.errors.title)}
          helperText={formik.errors.title}
          onChange={formik.handleChange}
          disabled={disabled}
          size="small"
          fullWidth
        />

        <Button
          sx={{ ml: 2 }}
          variant="contained"
          size="small"
          type="submit"
          disabled={disabled}
        >
          Сохранить
        </Button>

        <IconButton size="small" onClick={onCloseCreate} disabled={disabled}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Paper>
  );
};
